import React, { useEffect, useState } from "react";
import Image from "../assets/RIGVE - Premium Texture/PD_2-1536x1025.webp";

export const BathroomLanding = () => {
  const [aboutData, setAboutData] = useState([]);
  const [extraDetails, setExtraDetails] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://webadmin.naturx.co.in/api/get_about",
        );
        const result = await response.json();
        if (result.status === 1) {
          setAboutData(result.data);
          setExtraDetails(result.extra_details);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);
  const stats = [
    {
      number: extraDetails?.total_awwards || "15",
      label: "Awwards",
      suffix: "",
    },
    {
      number: extraDetails?.total_projects || "1024",
      label: "Projects",
      suffix: "",
    },
    {
      number: extraDetails?.total_clients || "2024",
      label: "Happy clients",
      suffix: "+",
    },
  ];

  return (
    <div className="bg-white mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pb-16">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Left Content Section */}
          <div className="flex flex-col justify-center space-y-6">
            <div className="space-y-4">
              <p className="text-gray-600 text-md">{aboutData[1]?.sub_title}</p>
              <h1 className="lg:text-2xl text-xl font-semibold text-gray-900 leading-tight">
                {aboutData[1]?.title}
              </h1>
            </div>

            <div className="space-y-4 text-gray-700">
              {aboutData[1]?.description?.split("\r\n\r\n")[0] && (
                <p className="text-md">
                  {aboutData[1]?.description.split("\r\n\r\n")[0]}
                </p>
              )}

              <h2 className="text-lg font-semibold">
                {aboutData[1]?.image_title}
              </h2>
              {aboutData[1]?.description?.split("\r\n\r\n")[0] && (
                <p className="text-md">
                  {aboutData[1]?.description.split("\r\n\r\n")[1]}
                </p>
              )}
            </div>

            <div className="flex items-center justify-center flex-wrap gap-4">
              <button className="px-6 py-3 bg-orange-600 text-white rounded-3xl hover:bg-orange-700 transition-colors">
                <a href="Products/5/Interior%20Wall%20Textures">
                  Explore Products
                </a>
              </button>
              <button className="px-6 py-3 border border-gray-300 text-gray-700 rounded-3xl hover:bg-gray-50 transition-colors">
                <a href="contact">Contact Us</a>
              </button>
            </div>

            {/* Stats Section */}
            <div className="grid  grid-cols-3 md:px-2 px-8 gap-8 pt-8">
              {stats.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="lg:text-3xl text-xl font-bold text-gray-900">
                    {stat.number}
                    {stat.suffix}
                  </div>
                  <div className="text-gray-600 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Image Section */}
          <div className="relative h-[500px] lg:h-[600px] rounded-lg overflow-hidden">
            <img
              src={aboutData[1]?.image}
              alt="Modern bathroom design"
              className="w-full h-full object-cover rounded-lg shadow-xl"
            />
            {/* Decorative Element */}
            <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-orange-600 rounded-full opacity-20 z-0"></div>
          </div>
        </div>
      </div>
    </div>
  );
};
